export interface NavItem {
  label: string;
  path: string;
  icon: string;
  end?: boolean;
}

export const teacherNav: NavItem[] = [
  { label: 'Dashboard', path: '/panel', icon: 'ri-dashboard-3-line', end: true },
  { label: 'Ders Programı', path: '/panel/program', icon: 'ri-calendar-2-line' },
  { label: 'Dersler', path: '/panel/dersler', icon: 'ri-book-open-line' },
  { label: 'Ders Kayıtları', path: '/panel/kayitlar', icon: 'ri-vidicon-line' },
  { label: 'Dokümanlar', path: '/panel/dokumanlar', icon: 'ri-file-pdf-2-line' },
  { label: 'Ödevler', path: '/panel/odevler', icon: 'ri-task-line' },
  { label: 'Öğrenciler', path: '/panel/ogrenciler', icon: 'ri-user-star-line' },
  { label: 'Grup Yönetimi', path: '/panel/gruplar', icon: 'ri-team-line' },
  { label: 'Duyurular', path: '/panel/duyurular', icon: 'ri-megaphone-line' },
  { label: 'WhatsApp Grupları', path: '/panel/whatsapp', icon: 'ri-whatsapp-line' },
  { label: 'Ödeme / Paket', path: '/panel/odeme', icon: 'ri-wallet-3-line' },
  { label: 'Raporlar', path: '/panel/raporlar', icon: 'ri-bar-chart-2-line' },
  { label: 'Ayarlar', path: '/panel/ayarlar', icon: 'ri-settings-3-line' },
  { label: 'Yardım', path: '/panel/yardim', icon: 'ri-questionnaire-line' },
];

export const studentNav: NavItem[] = [
  { label: 'Ana Sayfa', path: '/ogrenci', icon: 'ri-home-5-line', end: true },
  { label: 'Ders Programım', path: '/ogrenci/program', icon: 'ri-calendar-2-line' },
  { label: 'Ders Kayıtlarım', path: '/ogrenci/kayitlar', icon: 'ri-vidicon-line' },
  { label: 'Dokümanlarım', path: '/ogrenci/dokumanlar', icon: 'ri-file-pdf-2-line' },
  { label: 'Ödevlerim', path: '/ogrenci/odevler', icon: 'ri-task-line' },
  { label: 'Duyurular', path: '/ogrenci/duyurular', icon: 'ri-megaphone-line' },
  { label: 'WhatsApp Grubum', path: '/ogrenci/whatsapp', icon: 'ri-whatsapp-line' },
  { label: 'Profilim', path: '/ogrenci/profil', icon: 'ri-user-3-line' },
];